export default "__VITE_ASSET__TZ5Qhqru__"